import { useQuery } from "@apollo/react-hooks";
import { MY_TIMESHEET_GET_EXAMINERS } from "my-timesheet/graphql";

export const useMyTimesheetExaminers = ({
  contractCode,
  locale,
}: {
  contractCode: string;
  locale: string;
}) => {
  const { data, loading, error } = useQuery(MY_TIMESHEET_GET_EXAMINERS, {
    fetchPolicy: "cache-and-network",
    variables: {
      contractCode,
      locale,
    },
  });

  return {
    data: data?.getMyTimesheetExaminersName || [],
    loading,
    error,
  };
};

export default useMyTimesheetExaminers;
